import React from 'react';

export function ThumbnailSkeleton(): React.ReactElement {
  return (
    <div className="odin-animate-pulse odin-bg-gray-300 odin-w-full odin-h-full odin-rounded-md" />
  );
}
